<div *ngIf="loading"
     class="loading-overlay">
  <i class="text-secondary fa fa-2x fa-spinner fa-spin"></i>
  <h3 class="mt-3 ml-1 text-secondary">Generando datos de facturación...</h3>
</div>

<div class="row">


  <!-- Salidas B2B -->

  <div class="col-4">
    <span *ngIf="
     datosFacturacion.length">
      <div class="card border border-info rounded">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h2>Salidas (Pedidos B2B)</h2>
            <!--
                  <button class="btn btn-seccondary mb-2"
                        [disabled]="loading"
                        (click)="abrirPdfClick()">
                    <i class="fa fa-spinner fa-spin"
                       *ngIf="loading"></i> Abrir detalle</button>
                -->

          </div>

          <!-- RESUMEN -->

          <table class="table table-sm table-striped table-bordered table-hover">

            <thead>
              <tr>
                <th class="text-info"
                    style="text-align: right;">Totales de {{ totales.salidasB2B.porSalida.Cantidad | number: '0.0':'es'}} Pedidos enviados </th>
                <th style="text-align: right;">Cantidad </th>
                <th style="text-align: right;">Precio </th>
                <th style="text-align: right;">Importe </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: right;">Líneas Mínimo</td>
                <td style="text-align: right;">{{ totales.salidasB2B.lineasMinimo.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2B._pedidoTipos.length === 3"> {{ totales.salidasB2B.lineasMinimo.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2B.lineasMinimo.Importe | euroCurrency }} </td>
              </tr>

              <tr>
                <td style="text-align: right;">Líneas Adicionales</td>
                <td style="text-align: right;">{{ totales.salidasB2B.lineasAdicionales.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2B._pedidoTipos.length === 3"> {{ totales.salidasB2B.lineasAdicionales.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2B.lineasAdicionales.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <td style="text-align: right;">Por unidad</td>
                <td style="text-align: right;">{{ totales.salidasB2B.unidades.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2B._pedidoTipos.length === 3"> {{ totales.salidasB2B.unidades.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2B.unidades.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <td style="text-align: right;">Horas empleadas</td>
                <td style="text-align: right;">{{ totales.salidasB2B.horas.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.horas.Precio | euroCurrency }}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.horas.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <!-- LITERAL 'por salida' en tabla clientes -> fac_salida_LiteralPrecioFijo -->
                <td style="text-align: right;">{{ totales.cliente.fac_salida_LiteralPrecioFijo}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.porSalida.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2B._pedidoTipos.length === 3"> {{ totales.salidasB2B.porSalida.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2B.porSalida.Importe | euroCurrency}}</td>
              </tr>

              <tr *ngIf="totales.salidas.lineasConLote.Importe > 0 ">
                <td style="text-align: right;">Líneas que gestionan lote</td>
                <td style="text-align: right;">{{ totales.salidasB2B.lineasConLote.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2B._pedidoTipos.length === 3"> {{ totales.salidasB2B.lineasConLote.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2B.lineasConLote.Importe | euroCurrency}}</td>
              </tr>

              <tr *ngIf="totales.salidas.porPales.Importe > 0 ">
                <td style="text-align: right;">Por carga de palés</td>
                <td style="text-align: right;">{{ totales.salidasB2B.porPales.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2B._pedidoTipos.length === 3"> {{ totales.salidasB2B.porPales.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2B.porPales.Importe | euroCurrency}}</td>
              </tr>


              <tr>
                <td class="text-info font-weight-bold"
                    style="text-align: right;">PACKAGING </td>
                <td style="text-align: right;"> </td>
                <td style="text-align: right;"> </td>
                <td style="text-align: right;"> </td>
              </tr>


              <tr *ngIf="totales.salidas.porPackaging.Importe >0 ">
                <td style="text-align: right;">Precio fijo</td>
                <td style="text-align: right;">{{ totales.salidasB2B.porPackaging.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.porPackaging.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.porPackaging.Importe | euroCurrency }} </td>
              </tr>

              <tr *ngIf="totales.salidas.pale01.Importe >0">
                <td style="text-align: right;">Palé NO retornable</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale02.Importe >0 ">
                <td style="text-align: right;">Palé Europeo</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale03.Importe >0">
                <td style="text-align: right;">Palé Americano</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale03.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale04.Importe >0">
                <td style="text-align: right;">Palé plástico</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale04.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale04.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale04.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale05.Importe >0">
                <td style="text-align: right;">Palé Ignífugo</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale05.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale05.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.pale05.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.caja01.Importe >0 ">
                <td style="text-align: right;">Cajas Pequeñas</td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.caja02.Importe >0 ">
                <td style="text-align: right;">Cajas Medianas</td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.caja03.Importe >0 ">
                <td style="text-align: right;">Cajas Grandes</td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.caja03.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.bolsa01.Importe >0 ">
                <td style="text-align: right;">Bolsas Pequeñas</td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.bolsa02.Importe >0 ">
                <td style="text-align: right;">Bolsas Medianas</td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.bolsa03.Importe >0 ">
                <td style="text-align: right;">Bolsas Grandes</td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.bolsa03.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.burbuja.Importe >0 ">
                <td style="text-align: right;">Burbuja</td>
                <td style="text-align: right;">{{ totales.salidasB2B.burbuja.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.burbuja.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.burbuja.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.viruta.Importe >0 ">
                <td style="text-align: right;">Viruta</td>
                <td style="text-align: right;">{{ totales.salidasB2B.viruta.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.viruta.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.viruta.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.papel.Importe >0 ">
                <td style="text-align: right;">Papel Kraft</td>
                <td style="text-align: right;">{{ totales.salidasB2B.papel.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.papel.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.papel.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.otros.Importe >0 ">
                <td style="text-align: right;">Otros</td>
                <td style="text-align: right;">{{ totales.salidasB2B.otros.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2B.otros.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2B.otros.Importe | euroCurrency }} </td>
              </tr>
            </tbody>

            <tfoot>
              <tr class="total-row">
                <td style="text-align: right;"><strong>Total</strong></td>
                <td></td>
                <td></td>
                <td style="text-align: right;"><strong>{{ totales.salidasB2B._sumas.Importe | euroCurrency }}</strong></td>
              </tr>
            </tfoot>
          </table>



        </div>
      </div>
    </span>
  </div>



  <!-- Salidas B2C -->

  <div class="col-4">
    <span *ngIf="
     datosFacturacion.length">
      <div class="card border border-info rounded">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h2>Salidas (Pedidos B2C)</h2>
            <!--
                  <button class="btn btn-seccondary mb-2"
                        [disabled]="loading"
                        (click)="abrirPdfClick()">
                    <i class="fa fa-spinner fa-spin"
                       *ngIf="loading"></i> Abrir detalle</button>
                -->

          </div>

          <!-- RESUMEN -->

          <table class="table table-sm table-striped table-bordered table-hover">

            <thead>
              <tr>
                <th class="text-info"
                    style="text-align: right;">Totales de {{ totales.salidasB2C.porSalida.Cantidad | number: '0.0':'es'}} Pedidos enviados </th>
                <th style="text-align: right;">Cantidad </th>
                <th style="text-align: right;">Precio </th>
                <th style="text-align: right;">Importe </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: right;">Líneas Mínimo</td>
                <td style="text-align: right;">{{ totales.salidasB2C.lineasMinimo.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2C._pedidoTipos.length === 3"> {{ totales.salidasB2C.lineasMinimo.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2C.lineasMinimo.Importe | euroCurrency }} </td>
              </tr>

              <tr>
                <td style="text-align: right;">Líneas Adicionales</td>
                <td style="text-align: right;">{{ totales.salidasB2C.lineasAdicionales.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2C._pedidoTipos.length === 3"> {{ totales.salidasB2C.lineasAdicionales.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2C.lineasAdicionales.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <td style="text-align: right;">Por unidad</td>
                <td style="text-align: right;">{{ totales.salidasB2C.unidades.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2C._pedidoTipos.length === 3"> {{ totales.salidasB2C.unidades.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2C.unidades.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <td style="text-align: right;">Horas empleadas</td>
                <td style="text-align: right;">{{ totales.salidasB2C.horas.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.horas.Precio | euroCurrency }}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.horas.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <!-- LITERAL 'por salida' en tabla clientes -> fac_salida_LiteralPrecioFijo -->
                <td style="text-align: right;">{{ totales.cliente.fac_salida_LiteralPrecioFijo}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.porSalida.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2C._pedidoTipos.length === 3"> {{ totales.salidasB2C.porSalida.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2C.porSalida.Importe | euroCurrency}}</td>
              </tr>

              <tr *ngIf="totales.salidas.lineasConLote.Importe > 0 ">
                <td style="text-align: right;">Líneas que gestionan lote</td>
                <td style="text-align: right;">{{ totales.salidasB2C.lineasConLote.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2C._pedidoTipos.length === 3"> {{ totales.salidasB2C.lineasConLote.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2C.lineasConLote.Importe | euroCurrency}}</td>
              </tr>

              <tr *ngIf="totales.salidas.porPales.Importe > 0 ">
                <td style="text-align: right;">Por carga de palés</td>
                <td style="text-align: right;">{{ totales.salidasB2C.porPales.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidasB2C._pedidoTipos.length === 3"> {{ totales.salidasB2C.porPales.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidasB2C.porPales.Importe | euroCurrency}}</td>
              </tr>


              <tr>
                <td class="text-info font-weight-bold"
                    style="text-align: right;">PACKAGING </td>
                <td style="text-align: right;"> </td>
                <td style="text-align: right;"> </td>
                <td style="text-align: right;"> </td>
              </tr>


              <tr *ngIf="totales.salidas.porPackaging.Importe >0 ">
                <td style="text-align: right;">Precio fijo</td>
                <td style="text-align: right;">{{ totales.salidasB2C.porPackaging.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.porPackaging.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.porPackaging.Importe | euroCurrency }} </td>
              </tr>

              <tr *ngIf="totales.salidas.pale01.Importe >0 ">
                <td style="text-align: right;">Palé NO retornable</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale02.Importe >0 ">
                <td style="text-align: right;">Palé Europeo</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale03.Importe >0 ">
                <td style="text-align: right;">Palé Americano</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale03.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale04.Importe >0 ">
                <td style="text-align: right;">Palé plástico</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale04.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale04.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale04.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale05.Importe >0 ">
                <td style="text-align: right;">Palé Ignífugo</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale05.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale05.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.pale05.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.caja01.Importe >0 ">
                <td style="text-align: right;">Cajas Pequeñas</td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.caja02.Importe >0 ">
                <td style="text-align: right;">Cajas Medianas</td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.caja03.Importe >0 ">
                <td style="text-align: right;">Cajas Grandes</td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.caja03.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.bolsa01.Importe >0 ">
                <td style="text-align: right;">Bolsas Pequeñas</td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.bolsa02.Importe >0 ">
                <td style="text-align: right;">Bolsas Medianas</td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.bolsa03.Importe >0 ">
                <td style="text-align: right;">Bolsas Grandes</td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.bolsa03.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.burbuja.Importe >0 ">
                <td style="text-align: right;">Burbuja</td>
                <td style="text-align: right;">{{ totales.salidasB2C.burbuja.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.burbuja.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.burbuja.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.viruta.Importe >0 ">
                <td style="text-align: right;">Viruta</td>
                <td style="text-align: right;">{{ totales.salidasB2C.viruta.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.viruta.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.viruta.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.papel.Importe >0 ">
                <td style="text-align: right;">Papel Kraft</td>
                <td style="text-align: right;">{{ totales.salidasB2C.papel.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.papel.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.papel.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.otros.Importe >0 ">
                <td style="text-align: right;">Otros</td>
                <td style="text-align: right;">{{ totales.salidasB2C.otros.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidasB2C.otros.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidasB2C.otros.Importe | euroCurrency }} </td>
              </tr>
            </tbody>

            <tfoot>
              <tr class="total-row">
                <td style="text-align: right;"><strong>Total</strong></td>
                <td></td>
                <td></td>
                <td style="text-align: right;"><strong>{{ totales.salidasB2C._sumas.Importe | euroCurrency }}</strong></td>
              </tr>
            </tfoot>
          </table>



        </div>
      </div>
    </span>
  </div>






  <!-- Salidas -->

  <div class="col-4">
    <span *ngIf="datosFacturacion.length">
      <div class="card border border-info rounded">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <!-- <h2>Salidas (Pedidos {{totales.salidas._pedidoTipos}})</h2> -->
            <h2>Salidas (Pedidos B2B+B2C)</h2>
            <!--
                  <button class="btn btn-seccondary mb-2"
                        [disabled]="loading"
                        (click)="abrirPdfClick()">
                    <i class="fa fa-spinner fa-spin"
                       *ngIf="loading"></i> Abrir detalle</button>
                -->

          </div>

          <!-- RESUMEN -->

          <table class="table table-sm table-striped table-bordered table-hover">

            <thead>
              <tr>
                <th class="text-info"
                    style="text-align: right;">Totales de {{ totales.salidas.porSalida.Cantidad | number: '0.0':'es'}} Pedidos enviados </th>
                <th style="text-align: right;">Cantidad </th>
                <th style="text-align: right;">Precio </th>
                <th style="text-align: right;">Importe </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: right;">Líneas Mínimo</td>
                <td style="text-align: right;">{{ totales.salidas.lineasMinimo.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidas._pedidoTipos.length === 3"> {{ totales.salidas.lineasMinimo.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidas.lineasMinimo.Importe | euroCurrency }} </td>
              </tr>

              <tr>
                <td style="text-align: right;">Líneas Adicionales</td>
                <td style="text-align: right;">{{ totales.salidas.lineasAdicionales.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidas._pedidoTipos.length === 3"> {{ totales.salidas.lineasAdicionales.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidas.lineasAdicionales.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <td style="text-align: right;">Por unidad</td>
                <td style="text-align: right;">{{ totales.salidas.unidades.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidas._pedidoTipos.length === 3"> {{ totales.salidas.unidades.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidas.unidades.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <td style="text-align: right;">Horas empleadas</td>
                <td style="text-align: right;">{{ totales.salidas.horas.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">{{ totales.salidas.horas.Precio | euroCurrency }}</td>
                <td style="text-align: right;">{{ totales.salidas.horas.Importe | euroCurrency}}</td>
              </tr>

              <tr>
                <!-- LITERAL 'por salida' en tabla clientes -> fac_salida_LiteralPrecioFijo -->
                <td style="text-align: right;">{{ totales.cliente.fac_salida_LiteralPrecioFijo}}</td>
                <td style="text-align: right;">{{ totales.salidas.porSalida.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidas._pedidoTipos.length === 3"> {{ totales.salidas.porSalida.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidas.porSalida.Importe | euroCurrency}}</td>
              </tr>

              <tr *ngIf="totales.salidas.lineasConLote.Importe > 0 ">
                <td style="text-align: right;">Líneas que gestionan lote</td>
                <td style="text-align: right;">{{ totales.salidas.lineasConLote.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidas._pedidoTipos.length === 3"> {{ totales.salidas.lineasConLote.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidas.lineasConLote.Importe | euroCurrency}}</td>
              </tr>

              <tr *ngIf="totales.salidas.porPales.Importe > 0 ">
                <td style="text-align: right;">Por carga de palés</td>
                <td style="text-align: right;">{{ totales.salidas.porPales.Cantidad | number: '0.0':'es' }}</td>
                <td style="text-align: right;">
                  <span *ngIf="totales.salidas._pedidoTipos.length === 3"> {{ totales.salidas.porPales.Precio | euroCurrency }} </span>
                </td>
                <td style="text-align: right;">{{ totales.salidas.porPales.Importe | euroCurrency}}</td>
              </tr>


              <tr>
                <td class="text-info font-weight-bold"
                    style="text-align: right;">PACKAGING </td>
                <td style="text-align: right;"> </td>
                <td style="text-align: right;"> </td>
                <td style="text-align: right;"> </td>
              </tr>


              <tr *ngIf="totales.salidas.porPackaging.Importe >0 ">
                <td style="text-align: right;">Precio fijo</td>
                <td style="text-align: right;">{{ totales.salidas.porPackaging.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.porPackaging.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.porPackaging.Importe | euroCurrency }} </td>
              </tr>

              <tr *ngIf="totales.salidas.pale01.Importe >0 ">
                <td style="text-align: right;">Palé NO retornable</td>
                <td style="text-align: right;">{{ totales.salidas.pale01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.pale01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.pale01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale02.Importe >0 ">
                <td style="text-align: right;">Palé Europeo</td>
                <td style="text-align: right;">{{ totales.salidas.pale02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.pale02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.pale02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale03.Importe >0 ">
                <td style="text-align: right;">Palé Americano</td>
                <td style="text-align: right;">{{ totales.salidas.pale03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.pale03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.pale03.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale04.Importe >0 ">
                <td style="text-align: right;">Palé plástico</td>
                <td style="text-align: right;">{{ totales.salidas.pale04.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.pale04.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.pale04.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.pale05.Importe >0 ">
                <td style="text-align: right;">Palé Ignífugo</td>
                <td style="text-align: right;">{{ totales.salidas.pale05.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.pale05.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.pale05.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.caja01.Importe >0 ">
                <td style="text-align: right;">Cajas Pequeñas</td>
                <td style="text-align: right;">{{ totales.salidas.caja01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.caja01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.caja01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.caja02.Importe >0 ">
                <td style="text-align: right;">Cajas Medianas</td>
                <td style="text-align: right;">{{ totales.salidas.caja02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.caja02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.caja02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.caja03.Importe >0 ">
                <td style="text-align: right;">Cajas Grandes</td>
                <td style="text-align: right;">{{ totales.salidas.caja03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.caja03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.caja03.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.bolsa01.Importe >0 ">
                <td style="text-align: right;">Bolsas Pequeñas</td>
                <td style="text-align: right;">{{ totales.salidas.bolsa01.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.bolsa01.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.bolsa01.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.bolsa02.Importe >0 ">
                <td style="text-align: right;">Bolsas Medianas</td>
                <td style="text-align: right;">{{ totales.salidas.bolsa02.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.bolsa02.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.bolsa02.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.bolsa03.Importe >0 ">
                <td style="text-align: right;">Bolsas Grandes</td>
                <td style="text-align: right;">{{ totales.salidas.bolsa03.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.bolsa03.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.bolsa03.Importe | euroCurrency }} </td>
              </tr>


              <tr *ngIf="totales.salidas.burbuja.Importe >0 ">
                <td style="text-align: right;">Burbuja</td>
                <td style="text-align: right;">{{ totales.salidas.burbuja.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.burbuja.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.burbuja.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.viruta.Importe >0 ">
                <td style="text-align: right;">Viruta</td>
                <td style="text-align: right;">{{ totales.salidas.viruta.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.viruta.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.viruta.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.papel.Importe >0 ">
                <td style="text-align: right;">Papel Kraft</td>
                <td style="text-align: right;">{{ totales.salidas.papel.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.papel.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.papel.Importe | euroCurrency }} </td>
              </tr>
              <tr *ngIf="totales.salidas.otros.Importe >0 ">
                <td style="text-align: right;">Otros</td>
                <td style="text-align: right;">{{ totales.salidas.otros.Cantidad | number: '0.0':'es'}}</td>
                <td style="text-align: right;">{{ totales.salidas.otros.Precio | euroCurrency }} </td>
                <td style="text-align: right;">{{ totales.salidas.otros.Importe | euroCurrency }} </td>
              </tr>
            </tbody>

            <tfoot>
              <tr class="total-row">
                <td style="text-align: right;"><strong>Total</strong></td>
                <td></td>
                <td></td>
                <td style="text-align: right;"><strong>{{ totales.salidas._sumas.Importe | euroCurrency }}</strong></td>
              </tr>
            </tfoot>
          </table>



        </div>
      </div>
    </span>
  </div>


</div> <!-- row -->



<!-- Sin datos -->
<span *ngIf="sinDatos">
  <div class="card border border-info rounded">
    <div class="card-body">
      <h2>SALIDAS</h2>
      <h3 class="text-success"> Sin Datos</h3>
    </div>
  </div>
</span>